export class ProductionDateGateway {
    retrieveCurrentDate() {
        return Promise.resolve(new Date());
    }
}
